import { render, staticRenderFns } from "./Goodsdetail.vue?vue&type=template&id=027cdaae&scoped=true"
import script from "./Goodsdetail.vue?vue&type=script&lang=js"
export * from "./Goodsdetail.vue?vue&type=script&lang=js"
import style0 from "./Goodsdetail.vue?vue&type=style&index=0&id=027cdaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027cdaae",
  null
  
)

export default component.exports